export default __webpack_public_path__ + "static/media/loading2.72382aef.gif";